import { getNavigationFeaturesListEndpoint, getNavigationListEndpoint } from "@/api/navigation-endpoints";
import { DeviceFeatureResponse, DeviceNavigationResponse } from "@/types/navigationsList";
import api from "./axios";

export const getNavigationList = async (deviceUuid: string, signal?: AbortSignal): Promise<DeviceNavigationResponse> => {
    const response = await api.get<DeviceNavigationResponse>(
        getNavigationListEndpoint(deviceUuid),
        {
            withCredentials: true,
            signal,
        }
    );
    return response.data;
}

//export const getNavigationFeaturesList = async (deviceUuid: string, featureRef: string, signal?: AbortSignal): Promise<DeviceFeatureResponse> => {
//    const response = await api.post<DeviceFeatureResponse>(
//        getNavigationFeaturesListEndpoint(deviceUuid, featureRef),
//        {
//            withCredentials: true,
//            signal,
//            data: {
//                from: undefined,
//                to: undefined,
//            }

//        }
//    );
//    return response.data;
//}

type NavigationFeaturesRequest = {
    from?: string;
    to?: string;
};
export const getNavigationFeaturesList = async (deviceUuid: string,featureRef: string,request?: NavigationFeaturesRequest,signal?: AbortSignal): Promise<DeviceFeatureResponse> => {
    const body = request
        ? {
            from: request.from,
            to: request.to,
        }
        : {};

    const response = await api.post<DeviceFeatureResponse>(
        getNavigationFeaturesListEndpoint(deviceUuid, featureRef),
        body,
        {
            withCredentials: true,
            signal,
        }
    );

    return response.data;
};
